<div class="container">
    <div class="col-md-12">
        <!-- Forgot password -->
        <div class="card lgFrmCard login-verify-card"  *ngIf="showVerifyForm === 'forgotPassword'">
        <form [formGroup]="forgotPasswordForm" class="loginFormClass" autocomplete="off">
        <p class="text-center verify-heading"><b>Forgot your password?</b></p>
            <p class="">Resetting your password is easy, just enter the email address you registered with
                CanString AI.</p>
            <div class="form-group">
                <label class="form-label mandatoryLabel">Email <i
                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                <div class="input-field">
                    <input id="otp" name="otp" formControlName="email" id="email" name="email"
                        class="form-control" type="email" placeholder="Enter your registered email" autocomplete="off">
                </div>
                <span class="text-danger"
                    *ngIf="forgotPasswordForm.controls['email'].invalid && forgotPasswordForm.controls['email'].dirty && forgotPasswordForm.hasError('required','email') && forgotPasswordForm.hasError('pattern','email')">
                    please enter valid email.
                </span>
                
            </div>
            <button class="btn btn-primary signInBtn" type="submit" [disabled]="forgotPasswordForm.invalid"
                (click)="forgotPasswordFun()">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login" *ngIf="spinner">
                    <span class="sr-only">Loading...</span>
                </i>
                Submit
            </button>
            <p class="ReturnLoginTxt text-center"><a class="returnClass" (click)="goBack()">Back to Log
                    in</a>
            </p>
        </form>
        </div>
          <!-- verify section -->
        <div class="card lgFrmCard login-verify-card" *ngIf="showVerifyForm === 'verify'">
            <p class="text-center verify-heading">
                <b *ngIf="!getEmailVerifyResponseData?.is2faenabled">Please confirm
                    your email</b>
                <b *ngIf="getEmailVerifyResponseData?.is2faenabled">Please confirm Two Factor
                    Authentication</b>
            </p>
            <p class="text-center">We've sent a verification PIN to your email and mobile</p>
            <form [formGroup]="otpForm">
            <div class="form-group">
                <label class="form-label mandatoryLabel">Verification PIN <i
                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                <div class="input-field">
                    <input id="otp" name="otp" formControlName="userOTP" 
                        class="form-control" type="text" placeholder="Enter your PIN">
                </div>
                <!-- <span class="text-danger"
                *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].dirty && loginForm.hasError('required','email')">
                please enter valid email.
            </span> -->
               <div class="text-danger" *ngIf="otpFormSubmit && otpForm.controls['userOTP'].invalid">Enter valid PIN</div>
            </div>
            <button class="btn btn-primary signInBtn" type="submit" [disabled]="otpForm.invalid"
                (click)="submitOtp()">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login" *ngIf="spinner">
                    <span class="sr-only">Loading...</span>
                </i>
                Verify
            </button>
            </form>
            <p class="ReturnLoginTxt text-center"><a class="returnClass" (click)="goBack()">Return to Log in</a>
            </p>
        </div>

         <!-- otp form section -->
         <div class="card lgFrmCard login-verify-card" *ngIf="showVerifyForm === 'otp'">
            <form [formGroup]="passwordForm">
              
                <p class="text-center verify-heading"><b>Reset Password</b></p>
                <div class="form-group">
                    <label class="form-label mandatoryLabel"
                        [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">New Password<i
                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <div class="input-field">
                        <input class="form-control" [type]="type" formControlName="password" id="password"
                            name="password">
                        <span class="fa {{eyeIcon}} passwordEye" (click)="hideShowPassword()"></span>
                    </div>
                    <div *ngIf="submitted && f['password'].errors" class="invalid-feedback text-danger">
                        <div class="text-danger" *ngIf="f['password'].errors['required']">New password is
                            required
                        </div>
                        <div class="text-danger" *ngIf="f['password'].errors['minlength']">
                            Password must be at least 8 characters
                        </div>
                        <div class="text-danger" *ngIf="f['password'].errors['pattern']">Password must be at least 8 characters, and include at least 1 number and 1 special character( _, &#64;,  or $).</div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label mandatoryLabel">Confirm Password<i
                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="password" formControlName="confirmPassword" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }" />
                    <div *ngIf="submitted && f['confirmPassword'].errors" class="invalid-feedback text-danger">
                        <div class="text-danger" *ngIf="f['confirmPassword'].errors['required']">
                            Confirm password is required
                        </div>
                        <div class="text-danger" *ngIf="f['confirmPassword'].errors['matching']">
                            Passwords do not match. Please re-enter your password.
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary signInBtn" type="submit" (click)="onSubmit()">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login" *ngIf="spinner">
                        <span class="sr-only">Loading...</span>
                    </i>
                    Reset Password
                </button>
                <p class="ReturnLoginTxt text-center"><a class="returnClass" (click)="goBack()">Back to Log
                        in</a>
                </p>
            </form>
        </div>

         <!-- password updated success fully -->
         <div class="card lgFrmCard login-verify-card" *ngIf="showVerifyForm === 'passwordSuccess'">
            <p class="text-center verify-heading"><b>Password Updated SuccessFully</b></p>
            <div class="col-md-4 offset-md-4">
                <button class="btn btn-primary signInBtn passwordSuccessBtn" type="submit" (click)="goBack()">
                    Return to Login
                </button>
            </div>
        </div>
  </div>
</div>  
